<template>
  <translate
    tag="p"
    class="version"
    :tt="{ versionNumber: $config.public.alfredVersion }"
  >
    Version: {versionNumber}
  </translate>
</template>

<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class Version extends Vue {}

export default toNative(Version)
</script>
<style scoped>
.version {
  color: var(--colour-blue);
  font-size: var(--small);
  text-align: center;
  padding: 0.5em;
}
</style>
